import React, { useState } from 'react';
import VirtualCounterManager from '../api/VirtualCounterManager';
import Counter from './Counter';
import styles from './Diamond.module.scss';

const Diamond: React.FC<{
    url: string;
}> = ({ url }) => {
    const [initialized, setInitialized] = useState<boolean>(false);
    const [charCount, setCharCount] = useState<number>(0);

    const awaitAPICall = () => {
        if (initialized) return;
        const { checkedJackpotAt, endpointStatus, current } = VirtualCounterManager.getCounter(url);
        if (checkedJackpotAt > -Infinity && endpointStatus == 200) {
            setInitialized(true);
            setCharCount(current.current.toFixed().length);
        } else {
            // TODO: Should we mitigate repeat attempts? maybe limit?
            setTimeout(awaitAPICall, 500);
        }
    };

    // await numerals before animating the reveal
    awaitAPICall();

    return (
        <div data-character-count={charCount} data-initialized={initialized} className={`${styles['diamond-wrapper']} progressive-jackpot-counter`}>
            <img className={styles['diamond-backing']} src='/animations/progressive-jackpot/img/diamond-backing.png' alt='Enter To Win' />
            <Counter className={styles['diamond-roller']} url={url} decimalMerge='right' groupMerge='left' groupSize='micro' currencySize='monospaced' />
            <div className={styles['header-wrapper']}>
                <img src='/animations/progressive-jackpot/img/header-rolling.svg' alt='Rolling' className={styles['rolling']} />
                <img src='/animations/progressive-jackpot/img/header-jackpot.svg' alt='Jackpots!' className={styles['jackpots']} />
            </div>
        </div>
    );
};

export default Diamond;
